import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { TENANT_LOGO_QUERY } from '../../graphql/upload'
import { getRoleFromStorage } from '../../helpers/userData'
import tenantPagesRoleManagement from '../../staticRoleManagement/tenantRoleManagement'
import { Image } from '../../types/image'

export const UploadBoxForTenantLogo = () => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    tenantId: string
    tenantCode: string
  }>()

  const [getImages, { data, loading }] = useLazyQuery<{
    tenantLogo: Image
  }>(TENANT_LOGO_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getImages({
      variables: {
        tenantCode: Number(params.tenantCode)
      }
    })
  }, [])
  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = [
        {
          fileURL: data.tenantLogo.url,
          status: FileStatus.COMPLETED,
          fileName: data.tenantLogo.name,
          fileSize: data.tenantLogo.size,
          mediaID: data.tenantLogo.id
        }
      ]

      setImages(newImages)
    }
  }, [loading, data])

  const hasAccessToUploadLogoForTenant = tenantPagesRoleManagement
    .find((item) => item.route === '/tenant/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <>
      <UploadBox
        hasAccess={hasAccessToUploadLogoForTenant}
        loading={loading}
        entityCode={params.tenantCode}
        entityid={params.tenantId}
        entityType={'Tenant'}
        images={images}
        setImages={setImages}
        imageType={'Logo'}
      />
    </>
  )
}
